module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f48637af0d5cab2e44157cfe2537b386.png";